import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import * as moment from 'moment';
import { NotificationService } from '../../../../notification/shared/notification.service';
import { Client } from '../../../shared/client/client';
import { ClientService } from '../../../shared/client/client.service';
import { CommandeDetails, ListLigneCommande } from '../../shared/commande';
import { CommandeService } from '../../shared/commande.service';

@Component({
  selector: 'app-commande-confirm',
  templateUrl: './commande-confirm.component.html',
  styleUrls: ['./commande-confirm.component.scss']
})
export class CommandeConfirmComponent implements OnInit {

  loading: boolean = false;
  commandeDetails: CommandeDetails;
  currentClient: Client;
  isSideBarOpen: boolean = false;
  confirmData: ListLigneCommande[];
  isSelected: boolean = true;
  dateLivraison: string;
  commandeId: string;
  isTransmissible: boolean = true;
  isCommandeLingerie: boolean = false;

  constructor(
    private commandeService: CommandeService,
    private clientService: ClientService,
    private route: ActivatedRoute,
    private router: Router,
    private snackBar: MatSnackBar,
    private notificationService: NotificationService
  ) {
    moment.locale('fr');
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.commandeId = params.id;
      this.commandeService.getClient(params.id).subscribe(client => {
        this.currentClient = client;
        if (this.currentClient != null) {
          this.clientService.selectClient(this.currentClient)
          this.getCommandeInfos(this.commandeId);
        }
      })
    });
  }

  getCommandeInfos(id: string) {
    this.loading = true;
    this.commandeService.getCommandeDetails(id).subscribe(data => {
      this.commandeDetails = data;
      this.dateLivraison = data.date_livraison
      this.confirmData = this.commandeDetails.lod_ligne_commandes;
      if (data.inventaires && data.inventaires.length > 0) {
        this.isCommandeLingerie = true;
      }
      this.affichage();
      this.transmissible();
    })
  }

  transmissible() {
    if (this.commandeDetails.lod_ligne_commandes.every(ligne => ligne.quantite != null) && !this.commandeDetails.lod_ligne_commandes.every(ligne => ligne.quantite == 0)) {
      this.isTransmissible = true;
    } else {
      this.isTransmissible = false;
    }
  }

  // variable pdc pour savoir si la personne a cliqué sur "Pas de commande"
  transmettre(pdc?: boolean) {
    if (!pdc) {
      this.commandeService.audit({ code: "T" }).subscribe();
    }
    this.commandeService.sendCommande(this.commandeId, this.currentClient).subscribe(data => {
      this.router.navigate(['/escli/linge-hebergement/list']).then(async () => {
        let list = data as Array<string>;
        if (list.length > 0) {
          if (list.length == 1) {
            this.notificationService.notif("L'article " + list[0] + " n'est plus dans votre contrat, il est retiré de la commande", "warn", 5000);
          } else {
            this.notificationService.notif("Les articles " + list + " ne sont plus dans votre contrat, ils sont retirés de la commande", "warn", 5000);
          }
          const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));
          await sleep(5000);
        }
        this.notificationService.notif("Commande transmise", "notif");
      })
    })
  }

  pasDeCommande() {
    this.commandeService.audit({ code: "PDC" }).subscribe();
    let count = 0;
    this.commandeDetails.lod_ligne_commandes.forEach(ligne => {
      let article = {
        article: ligne.article.id,
        quantite: 0,
      }
      this.commandeService.updateCommandeDetails(this.commandeId, this.currentClient.id, ligne.id, article).subscribe(data => {
        count++;
        if (count == this.commandeDetails.lod_ligne_commandes.length) {
          this.transmettre(true);
        }
      });
    })
  }

  affichage() {
    let statut = this.commandeDetails.statut

    if (statut["code"] != "AT12H" && statut["code"] != "AS12H" && statut["code"] != "EA") {
      this.commandeService.audit({ code: "N" }).subscribe();
      this.router.navigate(['/escli']).then(() => {
        this.notificationService.notif("Cette page n'est pas disponible", 'error');
      })
    } else {
      this.commandeService.audit({ code: "P" }).subscribe();
    }
    this.loading = false;
  }

  modifier() {
    this.commandeService.audit({ code: "M" }).subscribe();
  }
}
